import axios from '@fs/zion-axios'
import useReactQuery from '../../../hooks/useReactQuery'
import { dataURItoBlob, svgToImage } from '../../../helpers/image_helpers'
import {
  deleteAvatar,
  getAvatarSpecs,
  getAllAvatars,
  saveAvatar,
  setActiveAvatar,
  updatePersonLite,
} from '../../../services'
import useReactQueryMutation from '../../../hooks/useReactQueryMutation'
import { qk } from '../../../hooks/queryKeys'

const BASE_ORCHESTRATION_URL = '/service/discovery/mystory/orchestration'

export const useSaveTreePersonLite = () => {
  return useReactQueryMutation({
    mutationFn: (treeLitePerson) => {
      if (!treeLitePerson) return Promise.reject(new Error('treeLitePerson is required'))
      const url = `${BASE_ORCHESTRATION_URL}/person/lite`
      return axios({
        method: 'post',
        url,
        data: treeLitePerson,
      })
    },
    mutationKey: ['save-tree-person-lite'],
  })
}

export const useGetAvatar = (avatarId) => {
  return useReactQuery({
    queryFn: () => getAvatarSpecs(avatarId),
    queryKey: qk.avatarSpecs(),
    staleTime: 0,
    enabled: true,
  })
}

export const useGetAllAvatars = (enabled) => {
  return useReactQuery({
    queryFn: () => getAllAvatars(enabled),
    queryKey: qk.currentUsersAvatars(),
    staleTime: 0,
    enabled,
  })
}

export const useSetActiveAvatar = () => {
  return useReactQueryMutation({
    mutationFn: setActiveAvatar,
    mutationKey: ['set-active-avatar'],
  })
}

export const useDeleteAvatar = () => {
  return useReactQueryMutation({
    mutationFn: deleteAvatar,
    mutationKey: ['delete-avatar'],
  })
}

export const useSaveAvatar = () => {
  return useReactQueryMutation({
    mutationFn: async ({ avatarSvg, avatarSpecs, avatarId, forPersonId }) => {
      const formData = new FormData()
      const dataUrl = await svgToImage({
        svg: avatarSvg,
        mimetype: 'image/png',
        quality: 0.92,
        width: 'auto',
        height: 'auto',
        outputFormat: 'base64',
      })
      const blob = dataURItoBlob(dataUrl)
      formData.set('imageFile', blob, 'avatar.png')
      formData.set('specs', avatarSpecs)
      return saveAvatar(forPersonId, formData, avatarId) // creates new or updates existing avatar
    },
    mutationKey: ['save-avatar'],
  })
}

export const useUpdatePersonLite = () =>
  useReactQueryMutation({
    mutationFn: updatePersonLite,
    mutationKey: ['update-person-lite'],
  })
